import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { blocker, loading, dealMethodsOption } from './utils';
import { service } from './base';
/** constant: 默认请求设置，需要loading文本为‘加载中’，报错抛出message， */

var BASE_OPTION = {
  url: '',
  noLoading: false,
  noMessage: false,
  loadingText: '加载中…'
};
/**
 * @description: 共用API调用方法，支持request函数调用以及request.get、request.post、request.put、request.delete方法调用
 * @description: 有需要可以添加别的方法
 * @param {CombineRequestOption} option // axios的option可以查文档，多了关于loading和是否显示错误信息message的参数: noLoading & noMessage
 * @return {Promise<CustomResponse>} { status, message, data } 格式返回数据
 */

var request = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var option,
        extend,
        res,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            option = _args.length > 0 && _args[0] !== undefined ? _args[0] : Object.assign({}, BASE_OPTION);
            extend = dealMethodsOption(option);

            if (!extend.noLoading) {
              loading.add(extend.loadingText || '');
            }

            _context.next = 5;
            return service(option);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", blocker.getResponseData(res, !extend.noLoading, !extend.noMessage));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function request() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @description: get请求的处理
 * @param {string} url
 * @param {any} params // 拼接到url上的参数
 * @param {CombineRequestOption} option // axios的option可以查文档，多了关于loading和是否显示错误信息message的参数: noLoading & noMessage
 * @return {Promise<CustomResponse>} { status, message, data } 格式返回数据
 */


request.get = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
    var params,
        option,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            params = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            option = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : Object.assign({}, BASE_OPTION);
            option.url = url;
            option.method = 'GET';
            option.params = params;
            _context2.next = 7;
            return request(option);

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * @description:  Request方法： post
 * @param {string} url
 * @param {any} params // 请求体数据
 * @param {CombineRequestOption} option // axios的option可以查文档，多了关于loading和是否显示错误信息message的参数: noLoading & noMessage
 * @return {Promise<CustomResponse>} { status, message, data } 格式返回数据
 */


request.post = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url) {
    var data,
        option,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            data = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            option = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : Object.assign({}, BASE_OPTION);
            option.url = url;
            option.method = 'POST';
            option.data = data;
            _context3.next = 7;
            return request(option);

          case 7:
            return _context3.abrupt("return", _context3.sent);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * @description:  Request方法： put
 * @param {string} url
 * @param {any} params // 请求体数据
 * @param {CombineRequestOption} option // axios的option可以查文档，多了关于loading和是否显示错误信息message的参数: noLoading & noMessage
 * @return {Promise<CustomResponse>} { status, message, data } 格式返回数据
 */


request.put = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url) {
    var data,
        option,
        _args4 = arguments;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            option = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : Object.assign({}, BASE_OPTION);
            option.url = url;
            option.method = 'PUT';
            option.data = data;
            _context4.next = 7;
            return request(option);

          case 7:
            return _context4.abrupt("return", _context4.sent);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x3) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * @description:  Request方法： delete
 * @param {string} url
 * @param {any} params // 请求体数据
 * @param {CombineRequestOption} option // axios的option可以查文档，多了关于loading和是否显示错误信息message的参数: noLoading & noMessage
 * @return {Promise<CustomResponse>} { status, message, data } 格式返回数据
 */


request.delete = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(url) {
    var data,
        option,
        _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            data = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            option = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : Object.assign({}, BASE_OPTION);
            option.url = url;
            option.method = 'DELETE';
            option.data = data;
            _context5.next = 7;
            return request(option);

          case 7:
            return _context5.abrupt("return", _context5.sent);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x4) {
    return _ref5.apply(this, arguments);
  };
}();

export { request };